import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "following-list-container"
}
const _hoisted_3 = {
  key: 0,
  class: "empty-followings"
}
const _hoisted_4 = {
  key: 1,
  class: "followings-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "user-details" }
const _hoisted_7 = { class: "username" }
const _hoisted_8 = { class: "follow-status" }
const _hoisted_9 = {
  key: 0,
  class: "pagination-wrapper"
}

import { ref, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getUserFollowings, getUserFollowers, followUser } from '@/user/api/userApi';
import { useRouter } from 'vue-router';
import OtherUserProfileModal from '../user/OtherUserProfileModal.vue'; // 导入用户信息弹窗组件

interface Props {
  modelValue: boolean;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
  (e: 'report-user', payload: { targetType: number, targetId: number }): void;
}

// 定义用户信息接口
interface UserInfo {
  id: number;
  name?: string;
  avatar?: string;
  isFolloweed?: number; // 从API返回的字段名: 是否关注 0否1是
  isFollowerd?: number; // 从API返回的字段名: 是否被关注 0否1是
}

// 定义分页响应接口
interface PageResponse<T> {
  total: number;
  records: T[];
  [key: string]: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FollowingListModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "close", "report-user"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 定义响应式变量
const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const router = useRouter();
const loading = ref(false);
const followings = ref<UserInfo[]>([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);
const showUserProfileModal = ref(false); // 控制用户信息弹窗显示
const selectedUserId = ref(0); // 当前选中的用户ID

// 移除旧的showUserProfile函数定义，使用下面这个
const showUserProfile = (userId: number) => {
  selectedUserId.value = userId;
  showUserProfileModal.value = true;
};

// 切换关注状态
const toggleFollowStatus = async (user: UserInfo, isUnfollow = false) => {
  try {
    // 如果用户未登录，提示登录
    if (!localStorage.getItem('token')) {
      ElMessage.warning('请先登录');
      router.push('/login');
      return;
    }

    let response: any;

    // 如果是已关注状态或者互相关注状态，提供取消关注选项
    if ((user.isFolloweed === 1 && user.isFollowerd === 1) || (user.isFolloweed === 1 && user.isFollowerd === 0) || isUnfollow) {
      // 调用API取消关注用户
      response = await followUser(user.id);
      if (response && response.code === 1) {
        // 更新用户关注状态
        user.isFolloweed = 0;
        ElMessage.success('已取消关注');
        
        // 更新关注数统计 - 不直接修改total，而是重新加载列表
      } else {
        ElMessage.error(response.msg || '取消关注失败');
        return;
      }
    } else {
      // 调用API关注用户
      response = await followUser(user.id);
      if (response && response.code === 1) {
        // 更新用户关注状态
        user.isFolloweed = 1;
        ElMessage.success('关注成功');
        
        // 更新关注数统计 - 不直接修改total，而是重新加载列表
      } else {
        ElMessage.error(response.msg || '关注失败');
        return;
      }
    }
    
    // 发送事件通知父组件更新统计数据
    emit('update-stats');
    

  } catch (error: any) {
    console.error('关注操作失败:', error);
    ElMessage.error('关注操作失败，请稍后再试');
  }
};

// 加载关注列表
const loadFollowings = async () => {
  try {
    loading.value = true;
    console.log('正在请求关注列表，参数:', { page: currentPage.value, pageSize: pageSize.value });
    
    const response: any = await getUserFollowings({
      page: currentPage.value,
      pageSize: pageSize.value
    });

    console.log('关注列表API响应:', response);
    
    // 检查API响应结构
    if (response.data && 'total' in response.data && 'records' in response.data) {
      // 直接是分页数据结构
      const pageData = response.data as PageResponse<UserInfo>;
      followings.value = pageData.records || [];
      total.value = pageData.total || 0;
    } else {
      console.error('API返回错误格式:', response.data);
      throw new Error('获取关注列表失败');
    }
  } catch (error: any) {
    console.error('获取关注列表失败:', error);
    followings.value = [];
    total.value = 0;
  } finally {
    loading.value = false;
  }
};

// 分页改变
const handlePageChange = (page: number) => {
  currentPage.value = page;
  loadFollowings();
};

// 每页数量改变
const handleSizeChange = (size: number) => {
  pageSize.value = size;
  currentPage.value = 1;
  loadFollowings();
};

// 关闭对话框
const handleClose = () => {
  emit('close');
};

// 处理关闭用户资料弹窗
const handleCloseModal = () => {
  showUserProfileModal.value = false;
};


// 监听弹窗显示状态变化
watch(dialogVisible, (newValue) => {
  if (newValue) {
    currentPage.value = 1;
    loadFollowings();
  }
});

// 处理举报用户事件
const handleReportUser = (payload: { targetType: number, targetId: number }) => {
  // 将事件向上冒泡
  emit('report-user', payload);
};

// 添加处理关注状态变化的函数
const handleFollowStatusChange = (payload: { userId: number, isFollowed: boolean, followeeCount: number, followerCount: number }) => {
  // 更新当前列表中对应用户的状态
  const userToUpdate = followings.value.find(user => user.id === payload.userId);
  if (userToUpdate) {
    // 更新关注状态
    userToUpdate.isFolloweed = payload.isFollowed ? 1 : 0;
    // 更新统计数
    userToUpdate.followeeCount = payload.followeeCount;
    userToUpdate.followerCount = payload.followerCount;
  }
  
  // 触发统计数据更新事件
  emit('update-stats');
};


return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
    title: "我的关注",
    width: "600px",
    "close-on-click-modal": false,
    "before-close": handleClose,
    class: "warm-theme-dialog"
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_skeleton, {
              rows: 4,
              animated: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (followings.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 暂无关注用户 "))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followings.value, (user) => {
                    return (_openBlock(), _createBlock(_component_el_card, {
                      key: user.id,
                      class: "following-item warm-card",
                      shadow: "never"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "user-info",
                          onClick: ($event: any) => (showUserProfile(user.id))
                        }, [
                          _createVNode(_component_el_avatar, {
                            size: 40,
                            src: user.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                            class: "warm-avatar"
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(user.name || '未知用户'), 1)
                          ])
                        ], 8, _hoisted_5),
                        _createElementVNode("div", _hoisted_8, [
                          (user.isFolloweed === 1 && user.isFollowerd === 1)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "success",
                                size: "small",
                                plain: "",
                                onClick: _withModifiers(($event: any) => (toggleFollowStatus(user)), ["stop"])
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode(" 互相关注 ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : (user.isFolloweed === 1 && user.isFollowerd === 0)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "info",
                                  size: "small",
                                  onClick: _withModifiers(($event: any) => (toggleFollowStatus(user, true)), ["stop"])
                                }, {
                                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createTextVNode(" 已关注 ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_el_button, {
                                  key: 2,
                                  type: "primary",
                                  size: "small",
                                  onClick: _withModifiers(($event: any) => (toggleFollowStatus(user)), ["stop"])
                                }, {
                                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                    _createTextVNode(" 关注 ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (total.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_el_pagination, {
                          "current-page": currentPage.value,
                          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                          "page-size": pageSize.value,
                          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
                          total: total.value,
                          "page-sizes": [5, 10, 15, 20],
                          layout: "total, sizes, prev, pager, next, jumper",
                          class: "warm-pagination",
                          onCurrentChange: handlePageChange,
                          onSizeChange: handleSizeChange
                        }, null, 8, ["current-page", "page-size", "total"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])),
      _createVNode(OtherUserProfileModal, {
        modelValue: showUserProfileModal.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showUserProfileModal).value = $event)),
        userId: selectedUserId.value,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (showUserProfileModal.value = false)),
        onReportUser: handleReportUser,
        onFollowStatusChange: handleFollowStatusChange
      }, null, 8, ["modelValue", "userId"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})